import { IonChip, IonIcon, IonLabel } from '@ionic/react'
import { bulb } from 'ionicons/icons'

export function WorksWarning() {
  return (
    <IonChip color='primary'>
      <IonIcon icon={bulb}></IonIcon>
      <IonLabel>
        Нельзя забронировать автомобиль пока у вас есть действующий договор
      </IonLabel>
    </IonChip>
  )
}
